import * as yup from 'yup';
import {
  MAX_PRODUCT_NAME_LENGTH,
  MIN_PRODUCT_NAME_LENGTH,
} from '../../constants/validationConstants';
import { isNameValid } from '../../helpers/validationHelper';
import { FIELD_TYPE } from '../EditSection/EditForm';
import { apiCreateFilterOption } from '../../helpers/api';
import { dispatcher } from '../../helpers/projectHelper';
import { updateFilter } from '../../redux/slicers/filters/filterSlicer';
import { InputController } from '../../components/hookForm/InputController';

export const nameSchema = {
  name: yup
    .string()
    .min(MIN_PRODUCT_NAME_LENGTH)
    .max(MAX_PRODUCT_NAME_LENGTH)
    .required('Texture name is required'),
};
export const skuSchema = {
  sku_id: yup.string(),
};
export const descriptionSchema = {
  description: yup.string(),
};
export const widthSchema = {
  width: yup.number().required('Width is required'),
};
export const heightSchema = {
  height: yup.number().required('Height is required'),
};
export const rotationSchema = {
  rotation: yup.number(),
};

export const formSchema = {
  ...nameSchema,
  ...skuSchema,
  ...descriptionSchema,
  ...widthSchema,
  ...heightSchema,
  ...rotationSchema,
};

export const getNameFields = (data) => [
  {
    name: 'name',
    placeholder: 'Texture name',
    value: data.name || '',
    validate: (name) => isNameValid(name),
  },
];

export const getSKUFields = (data) => [
  {
    name: 'sku_id',
    placeholder: 'Sku ID',
    value: data.sku_id || '',
  },
];

export const getWidthFields = (data) => [
  {
    name: 'width',
    placeholder: 'Width',
    value: data.width || '',
  },
];

export const getHeightFields = (data) => [
  {
    name: 'height',
    placeholder: 'Height',
    value: data.height || '',
  },
];

export const getRotationFields = (data) => [
  {
    name: 'rotation',
    value: data.rotation || 0,
    type: FIELD_TYPE.BUTTONS_LIST,
    options: [
      { label: 0, value: 0 },
      { label: 90, value: 90 },
      { label: 180, value: 180 },
      { label: 270, value: 270 },
    ],
  },
];

export const getDescriptionFields = (data) => [
  {
    name: 'description',
    placeholder: 'Description',
    value: data.description || '',
  },
];

export const getLiveLinksFields = (data) => [
  {
    name: 'live_links',
    placeholder: 'Live Links ( comma separated )',
    value: data.live_links || '',
    Component: ({ control }) => {
      return (
        <InputController
          placeholder="Live Links ( comma separated )"
          name="live_links"
          className="mb-3"
          multiline
          control={control}
          noResize
          height={172}
        />
      );
    },
  },
];

export const getCategoryFields = (filter, categoryValue) => {
  const name = `filter_${filter.id}`;

  const schema = {
    [name]: yup.array()
  };

  return {
    schema,
    fieldsConfig: [
      {
        name: name,
        placeholder: filter.label_name,
        type: 'select',
        value: categoryValue,

        selectProps: {
          options: filter.options,
          isSearchable: true,
          isMulti: true,
          creatable: true,
          components: {
            DropdownIndicator: null,
          },
          onCreateOption: async (newOptionName) => {
            const result = await apiCreateFilterOption({ filterId: filter.id, options: [newOptionName]})
            if (result?.id && result?.options) {
              dispatcher(updateFilter(result));
              const newOption = result.options.find(o => o.name.toLowerCase() === newOptionName.toLowerCase())
              return { value: newOption.id, label: newOption.name }
            }

            return;
          }
        },
      },
    ],
  };
};
